import React from "react";
import Typewriter from "typewriter-effect";
import Resume from "../../assets/docs/Resume-Oct23.pdf";
import { FaCloudDownloadAlt } from "react-icons/fa";
import "./Home.css";
import { useTheme } from "../../Context/ThemeContext";
import { BsFillMoonStarsFill, BsFillSunFill } from "react-icons/bs";
import Fade from "react-reveal/Fade";
import HeadShake from "react-reveal/HeadShake";
import Spin from "react-reveal/Spin";

const Home = () => {
  const [theme, setTheme] = useTheme();

  const handleTheme = () => {
    setTheme((prevState) => (prevState === "light" ? "dark" : "light"));
  };

  return (
    <>
      <div className="container-fluid home-container" id="home">
        <Spin>
          <div className="theme-btn" onClick={handleTheme}>
            {theme === "light" ? (
              <BsFillMoonStarsFill Fill size={30} />
            ) : (
              <BsFillSunFill size={30} />
            )}
          </div>
        </Spin>
        <div className="container home-content">
          <Fade top>
            <h1>
              Hi, I'm <br />
              <span style={{ color: "red" }}> Shivam Mishra </span> a
            </h1>
          </Fade>
          <Fade right>
            <h2>
              <Typewriter
                options={{
                  autoStart: true,
                  strings: [
                    "FullStack Developer! ",
                    "MernStack Developer! ",
                    "Angular Learner! ",
                    "ReactJs Developer! ",
                    "ReactNative Learner!",
                  ],
                  loop: true,
                }}
              />
            </h2>
          </Fade>
          <HeadShake>
            <div className="home-buttons">
              <a
                className="btn btn-hire"
                href="https://api.whatsapp.com/send?phone=7827146877"
                rel="noreferer"
                target="_blank"
              >
                Hire Me
              </a>
              <br />
              <a className="btn btn-cv" href={Resume} target="_blank">
                My Resume
              </a>
              <a
                className="btn btn-download"
                href={Resume}
                download="Resume-Oct23.pdf"
              >
                <FaCloudDownloadAlt size={21} />
              </a>
            </div>
          </HeadShake>
        </div>
      </div>
    </>
  );
};

export default Home;
